<mds-dialog dialogTitle="Report a Bug">
    <mds-dialog-content>
        <div class="flex flex-col gap-medpace">
            <span>
                Please describe below the situation in which the error occurred. Provide as many details as
                possible.</span
            >
            <span>
                Along with the submitted form, the information recorded during the error occurrence will be sent.
            </span>
            <mds-textarea
                label="Bug description"
                placeholder="Type here..."
                appearance="outline"
                name="bugDetails"
                [autoSize]="true"
                [cdkAutosizeMinRows]="8"
                [cdkAutosizeMaxRows]="8"
                [formCtrl]="reportBugFromGroup.controls.bugDetails"
            >
            </mds-textarea>
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button
                [id]="'cancel-btn'"
                mat-button
                mat-dialog-close
                label="Cancel"
                [variant]="'outline'"
                (clickEvent)="closeDialog()"
            ></mds-button>
            <mds-button
                [id]="'confirm-btn'"
                mat-button
                (clickEvent)="saveDialog()"
                label="Send"
                [color]="'primary'"
                [variant]="'filled'"
            ></mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
